<form #form="ngForm" class="flex flex-col gap-[1.35rem] mt-[.5rem] w-full justify-center align-middle">

  <div >
    <div>
      <div class=" width_100_percent">
        <div>
          <div class="flex flex-col gap-5">
            <div class="flex flex-col gap-1">
              <mat-label>{{"name" | translate}}</mat-label>
              <mat-form-field appearance="outline" floatLabel="never">
                <mat-icon matPrefix><i class="fa-sharp fa-regular fa-calendar-week"></i></mat-icon>
                <input matInput pattern="[a-zA-Zа-яА-ЯѓЃќЌјЈџЏѕЅжЖљЈчЧњЌЌѝЍ 0-9 ]*" type="text" [(ngModel)]="holidayData.name" #name="ngModel"
                       name="name" minlength="3" required=""
                       placeholder='{{"name" | translate}}'>
                <mat-error *ngIf="name && name.errors">
                <span
                *ngIf="name.errors['required']">{{"Required Field" | translate}}</span>
                  <span
                  *ngIf="name.errors['minlength']">{{"Required minimum 3 caracters" | translate}}</span>
                  <span
                  *ngIf="name.errors['pattern']">{{"Allowed letters and numbers" | translate}}</span>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="flex flex-col gap-1">
              <mat-label>{{"Select a date from" | translate}}</mat-label>
              <mat-form-field appearance="outline">
                <mat-icon matPrefix><i class="fa-regular fa-calendar"></i></mat-icon>
                <input matInput [matDatepicker]="picker" [(ngModel)]="holidayData.date"
                    [min]="yesterday" placeholder='{{"Select a date" | translate}}' #dateFrom="ngModel"
                    name="dateFrom" [matDatepickerFilter]="filterSundays" required>
                <mat-hint>{{"MM/DD/YYYY" | translate}}</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="picker" ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="dateFrom && dateFrom.errors">
                  <span *ngIf="dateFrom.errors['required']">{{"The field is required" | translate }}.</span>
                </mat-error>
            </mat-form-field>

            </div>

            <div class="flex flex-col gap-1 mb-1">
              <mat-label>{{"Select a date to" | translate}}</mat-label>
              <mat-form-field appearance="outline" >
                <mat-icon matPrefix><i class="fa-regular fa-calendar"></i></mat-icon>
                <input matInput [matDatepicker]="picker2"  [(ngModel)]="holidayData.dateTo"
                    [min]="yesterday" placeholder='{{"Select a date" | translate}}' #dateTo="ngModel"
                    name="dateTo" [matDatepickerFilter]="filterSundays" required>
                <mat-hint>{{"MM/DD/YYYY" | translate}}</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="picker2" ></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
                <mat-error *ngIf="dateTo && dateTo.errors">
                  <span *ngIf="dateTo.errors['required']">{{"The field is required" | translate }}.</span>
                </mat-error>
            </mat-form-field>

            
            <span class="text-center sm:max-w-2xl my-[1rem] opacity-80">{{"Select from when to when non working days" | translate}}</span>

            </div>



          </div>
        </div>
        <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem] w1/2">
          <button (click)="closePopup()" type="button"
            class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] uppercase bg-[#dadada] text-[#696767] hover:bg-[#c4c4c4] shadow-md active:scale-[0.985] active:shadow-sm">
            {{"back" | translate}}
          </button>
    
          <button [disabled]="!form.valid" [ngClass]="{
                'bg-[#b98d78] hover:bg-[#a57d6a] ': form,
                'bg-[#b98d78]/20 hover:bg-[#a57d6a]/20': !form
              }" (click)="addHoliday()" class="w-1/2 px-5 uppercase py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
            {{"save" | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
